<template>
  <div style="display: contents;">
    <ion-content ref="myContent" :fullscreen="true">
      <reserva-calendari v-show="step === 1" v-model="form.dates" :price="form.price" @continue="setStep(2)"
        @valid="setValid"></reserva-calendari>
      <reserva-tipus-vehicles :guest="guest" v-show="step === 2" v-model="form.vehicle_type_id" :dates="form.dates"
        :step="step" @back="step = 1" @continue="step = 3" @valid="setValid"></reserva-tipus-vehicles>
      <reserva-locations type="check_in" v-show="step === 3" v-model="form.checkin_location_id" :dates="form.dates"
        :vehicleTypeId="form.vehicle_type_id" @continue="step = 4" @valid="setValid" />
      <reserva-locations type="check_out" v-show="step === 4" v-model="form.checkout_location_id" :dates="form.dates"
        :vehicleTypeId="form.vehicle_type_id" :checkInLocationId="form.checkin_location_id" @back="step = 3"
        @continue="step = 5" @valid="setValid">
      </reserva-locations>
      <reserva-vehicles :guest="guest" v-show="step === 5" v-model="form.vehicles" :dates="form.dates" :step="step"
        :vehicleTypeId="form.vehicle_type_id" :checkInLocationId="form.checkin_location_id"
        :checkOutLocationId="form.checkout_location_id" @back="step = 4" @continue="step = 6"
        @valid="setValid"></reserva-vehicles>
      <reserva-addons v-show="step === 6" v-model="form.addons"></reserva-addons>
      <reserva-dades-client v-show="step === 7" v-model="form.client" @continue="step = 8"
        @valid="setValid" :price="form.price"></reserva-dades-client>
      <reserva-documentacio v-show="step === 8" v-model="form.documentation" @continue="step = 9" @valid="setValid">
      </reserva-documentacio>
      <reserva-condicions-legals v-show="step === 9" v-model="form.legal_signature" :form="form" @continue="step = 10"
        @valid="setValid"></reserva-condicions-legals>
      <reserva-confirmacio :guest="guest" :form="form" v-model="form.total_price" :forms="forms" v-if="step === 10"
        @add="$emit('add')"></reserva-confirmacio>
      <reserva-pagaments v-show="step === 10 && !guest" v-model="form.payments"></reserva-pagaments>
      <ion-item v-show="step === 10 && !guest">
        <ion-label style="white-space: break-spaces;">
          Enviar email de dipòsit
        </ion-label>
        <ion-checkbox slot="start" v-model="form.send_deposit_email"></ion-checkbox>
      </ion-item>
    </ion-content>
    <ion-footer>
      <ion-row style="display:flex;padding: 0 8px;">
        <ion-col style="flex:1;">
          <ion-button @click="$emit('back')" v-if="step === 1 && index > 0" color="light">{{ $t("bookings.back")
          }}</ion-button>
          <ion-button @click="setStep(step - 1)" v-if="step > 1" color="light">{{ $t("bookings.back") }}</ion-button>
        </ion-col>
        <ion-col style="flex:1;" class="price-col">
          <div v-if="form.price">{{ $filters.toCurrency(totalPrice) }}</div>
        </ion-col>
        <ion-col style="flex:1;" class="continue">
          <ion-button v-if="step < 10" :disabled="!valid[step]" @click="setStep(step + 1)">{{ $t("bookings.continue")
          }}</ion-button>
          <ion-button v-if="step === 10" @click="send">{{
            $t("bookings.confirm")
          }}</ion-button>
        </ion-col>
      </ion-row>
    </ion-footer>
    <iframe class="payment-iframe" v-if="paymentUrl" :src="paymentUrl">
    </iframe>
  </div>
</template>

<script>
import ReservaCalendari from "../components/reserva/ReservaCalendari.vue";
import ReservaVehicles from "../components/reserva/ReservaVehicles.vue";
import ReservaDadesClient from "../components/reserva/ReservaDadesClient.vue";
import ReservaCondicionsLegals from "../components/reserva/ReservaCondicionsLegals.vue";
import ReservaConfirmacio from "../components/reserva/ReservaConfirmacio.vue";
import ReservaLocations from "../components/reserva/ReservaLocations.vue";
import ReservaDocumentacio from "../components/reserva/ReservaDocumentacio.vue";
import ReservaPagaments from "../components/reserva/ReservaPagaments.vue";
import ReservaTipusVehicles from "../components/reserva/ReservaTipusVehicles.vue";
import ReservaAddons from "../components/reserva/ReservaAddons.vue";
import { defineComponent } from "vue";
import axios from "axios";
import { IonItem, IonCheckbox } from "@ionic/vue";

import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonFooter,
  IonButtons,
  modalController,
  toastController,
  loadingController,
  alertController,
} from "@ionic/vue";
import { close } from "ionicons/icons";
import { IonContent as content } from "@ionic/vue";
import CountryFlag from "vue-country-flag-next";

function generateUUID() { // Public Domain/MIT
  var d = new Date().getTime();//Timestamp
  var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16;//random number between 0 and 16
    if (d > 0) {//Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {//Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}
let source;

export default defineComponent({
  setup() {
    return {
      close,
      modalController,
    };
  },
  components: {
    ReservaCalendari,
    ReservaVehicles,
    ReservaDadesClient,
    ReservaCondicionsLegals,
    ReservaConfirmacio,
    ReservaLocations,
    ReservaDocumentacio,
    ReservaPagaments,
    ReservaTipusVehicles,
    ReservaAddons,
    IonContent,
    IonFooter,
    IonCheckbox,
    IonItem
  },
  data: () => ({
    form: null,
    valid: {
      1: false,
      2: false,
      3: true,
      4: true,
      5: false,
      6: true,
      7: false,
      8: false,
    },
    dates: [],
    step: 1,
    legalDialog: false,
    guest: false,
    paymentUrl: null,
  }),
  watch: {
    "form": {
      deep: true,
      handler(newVal) {
        this.$emit('update:modelValue', newVal)
      },
    },
    "form.dates": {
      deep: true,
      handler() {
        this.getPrice();
      },
    },
    "form.checkin_location_id"(newVal) {
      if (newVal !== null) {
        this.getPrice();
      }
    },
    "form.checkout_location_id"(newVal) {
      if (newVal !== null) {
        this.getPrice();
      }
    },
    "form.addons"(newVal) {
      if (newVal !== null) {
        this.getPrice();
      }
    },
    "form.vehicles"(newVehicles) {
      if (newVehicles !== null) {
        this.getPrice();
      }
    },
    "form.vehicle_type_id"(vehicleTypeId) {
      if (vehicleTypeId !== null) {
        // this.getPrice();
      }
    },
  },
  beforeMount() {
    this.form = this.modelValue;
  },
  mounted() {
    if (this.$route.query.locale) {
      this.$i18n.locale = this.$route.query.locale;
    }
    this.guest = !this.$store.getters.isAuthenticated;
    window.addEventListener(
      "message",
      (event) => {
        try {
          var messageObject = JSON.parse(event.data);
        } catch (e) {
          return;
        }
        if (messageObject.result) {
          this.paymentUrl = null;
          if (messageObject.result === "ok") {
            this.$swal({
              icon: "success",
              title: this.$t("bookings.successTitle"),
              html: this.$t("bookings.successDesc"),
              showCloseButton: false,
              showCancelButton: false,
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              heightAuto: false,
            });
          } else {
            this.$swal({
              icon: "error",
              title: this.$t("bookings.errorTitle"),
              html: this.$t("bookings.errorDesc"),
              showCloseButton: false,
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: this.$t("bookings.ok"),
              allowOutsideClick: false,
              allowEscapeKey: false,
              heightAuto: false,
            });
          }
        }
      },
      false
    );
  },
  methods: {
    async send() {
      const loading = await loadingController.create({});

      await loading.present();

      let reqs = [];

      let batch = (this.forms.length > 1) ? generateUUID() : null;
      for (const form of this.forms) {
        for (const vehicle of form.vehicles) {
          reqs.push(
            {
              send_deposit_email: form.send_deposit_email,
              start: form.dates.start,
              end: form.dates.end,
              vehicle_id: vehicle.id,
              client_name: form.client.client_name,
              client_id_doc: form.client.client_id_doc,
              client_email: form.client.client_email,
              client_phone: form.client.client_phone,
              client_country: form.client.client_country,
              client_address: form.client.client_address,
              client_signature: form.legal_signature,
              total_price: form.total_price / form.vehicles.length,
              addon_ids: form.addons.map((addon) => { return addon.id }),
              payments: form.payments,
              lang: this.$i18n.locale,
              num_bookings: form.vehicles.length,
              medias: form.documentation.id_front.concat(
                form.documentation.id_back,
                form.documentation.driver_license_front,
                form.documentation.driver_license_back
              ),
              checkin_location_id: form.checkin_location_id,
              checkout_location_id: form.checkout_location_id,
              batch: batch,
            }
          );
        }
      }

      async function sendSequentialPostRequests(dataArray) {
        const results = [];

        for (const postData of dataArray) {
          try {
            debugger;
            const response = await axios.post('/bookings', postData);
            console.log('Request completed:', response.data);
            results.push(response.data);
          } catch (error) {
            console.error('An error occurred:', error);
            throw error; // Rethrow the error to be caught later
          }
        }

        return results;
      }

      sendSequentialPostRequests(reqs)
        .then(async resp => {
          if (this.guest) {
            this.paymentUrl = resp[0].data.paymentUrl;
          } else {
            modalController.dismiss();
            const toast = await toastController.create({
              message: "Reserva creada correctament",
              duration: 2000,
            });
            return toast.present();
          }
        })
        .catch(async error => {
          if (error.response.data) {
            try {
              const toast = await toastController.create({
                message: Object.values(Object.values(error.response.data).flat()[1]).flat()[0],
                color: "warning",
                duration: 5000,
              });
              return toast.present();
            } catch (e) {
              const toast = await toastController.create({
                message: "Error al crear la reserva. Prova-ho més tard.",
                color: "danger",
                duration: 2000,
              });
              return toast.present();
            }
          
          } else {
            const toast = await toastController.create({
              message: "Error al crear la reserva. Prova-ho més tard.",
              color: "danger",
              duration: 2000,
            });
            return toast.present();
          }
        }).finally(() => {
          loading.dismiss();
        });
      
    },
    setValid(step, valid) {
      this.valid[step] = valid;
    },
    setStep(step) {
      if (this.step === 6 && step === 5 && this.guest) step = 4;
      this.step = step;
      this.$refs.myContent.$el.scrollToPoint(0, 0, 500);
      this.$forceUpdate();
    },
    getPrice() {
      if (this.form.dates.start === null || this.form.dates.end === null) return;

      // Check if a CancelToken.source has been assigned to the source variable, then call the cancel method when true.
      if (source) source.cancel('Operation canceled by the user.');

      // Assign the source factory to the source variable
      source = axios.CancelToken.source();

      const option = {
        cancelToken: source.token // add the cancel token, as an option for the request
      };

      axios
        .post("/bookings/price", {
          start: this.form.dates.start,
          end: this.form.dates.end,
          vehicles: this.form.vehicles.map((vehicle) => { return vehicle.id }),
          addon_ids: this.form.addons.map((addon) => { return addon.id }),
          checkin_location_id: this.form.checkin_location_id,
          checkout_location_id: this.form.checkout_location_id,
          vehicleTypeId: this.form.vehicle_type_id,
        }, option)
        .then((resp) => {
          this.form.price = resp.data;
        });
    },
    async closeModal() {
      const alert = await alertController.create({
        header: this.$t("bookings.cancelConfirmationTitle"),
        message: this.$t("bookings.cancelConfirmationDesc"),
        buttons: [
          {
            text: this.$t("bookings.exit"),
            cssClass: "secondary",
            id: "confirm-button",
            handler: () => {
              modalController.dismiss();
              parent.postMessage(JSON.stringify({ action: "close" }), "*");
            },
          },
          {
            text: this.$t("bookings.cancel"),
            role: "cancel",
          },
        ],
      });
      await alert.present();

      const { role } = await alert.onDidDismiss();
      console.log("onDidDismiss resolved with role", role);
    },
    setLang(lang) {
      this.$i18n.locale = lang;
    },
  },
  computed: {
    totalPrice() {
      let price = 0;
      for (const form of this.forms) {
        price += form.price.price;
      }
      return price;
    },
    progress() {
      return (this.step * 100) / 9;
    },
  },
  props: ['modelValue', 'forms', 'index']
});
</script>

<style lang="scss" scoped>
.v-sheet.v-stepper {
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
}

.continue ion-button {
  float: right;
}

.price-col {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 600;
  color: #0b5a85;
  position: relative;
  top: -1px;
}

ion-footer {
  background: white;
}

.payment-iframe {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999999;
  border: none;
}

.progress {
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  height: 4px;
  background: #3982b6;
  transition: ease all 0.5s;
}
</style>
